import { FC, useMemo } from 'react';
import { GoldOutlined } from '@ant-design/icons';
import { CryptoCountBuyAndSellChartProps } from '../../../../../../core/domain/overview/crypto-count-buy-and-sell';
import { ChartCard } from '../../components/chart-card/chart-card';
import { BarSeriesChart, CHART_COLORS, faNumber, mergeByDate, sumOf } from '../chart-commons';

interface Props {
    chartData: CryptoCountBuyAndSellChartProps;
    chartLoading: boolean;
}

const series = [
    { key: 'buys', name: 'خرید', color: CHART_COLORS.green },
    { key: 'sells', name: 'فروش', color: CHART_COLORS.red },
];

export const CryptoCountBuyAndSell: FC<Props> = ({ chartData, chartLoading }) => {
    const data = useMemo(
        () =>
            mergeByDate([
                { key: 'buys', data: chartData?.buys },
                { key: 'sells', data: chartData?.sells },
            ]),
        [chartData],
    );

    return (
        <ChartCard
            title="تعداد خرید و فروش های رمز ارزی"
            subtitle="تعداد سفارش‌های رمزارزی به تفکیک روز"
            icon={<GoldOutlined />}
            accent="purple"
            loading={chartLoading}
            empty={!data.length}
            stats={[
                { label: 'خرید', value: faNumber(sumOf(data, 'buys')), color: CHART_COLORS.green },
                { label: 'فروش', value: faNumber(sumOf(data, 'sells')), color: CHART_COLORS.red },
            ]}
        >
            <BarSeriesChart data={data} series={series} />
        </ChartCard>
    );
};
